// Store Imports
import { createReducer, on } from '@ngrx/store'
import {
	SHOW_PRIMARY_MENU,
	HIDDEN_PRIMARY_MENU,
	SHOW_SECONDARY_MENU,
	HIDDEN_SECONDARY_MENU,
} from '@store/actions'
import { IUiState, ESecondaryMenuType } from '@store/models'

export const initialUiState: IUiState = {
	menus: {
		primary: true,
		secondary: false,
		secondaryType: ESecondaryMenuType.none,
	},
}

export const uiReducer = createReducer(
	initialUiState,
	on(SHOW_PRIMARY_MENU, (previousState: IUiState): IUiState => {
		return { ...previousState, menus: { ...previousState.menus, primary: true } }
	}),
	on(HIDDEN_PRIMARY_MENU, (previousState: IUiState): IUiState => {
		return { ...previousState, menus: { ...previousState.menus, primary: false } }
	}),
	on(SHOW_SECONDARY_MENU, (previousState: IUiState, { secondaryType }): IUiState => {
		return {
			...previousState,
			menus: { ...previousState.menus, secondary: true, secondaryType },
		}
	}),
	on(HIDDEN_SECONDARY_MENU, (previousState: IUiState): IUiState => {
		return {
			...previousState,
			menus: { ...previousState.menus, secondary: false, secondaryType: ESecondaryMenuType.none },
		}
	})
)
